import { encodeUriAttributes, decodeUriAttributes } from '@intercom/embercom-composer/lib/attribute-encoding';
import { trim } from '@intercom/pulse/lib/computed-properties';
import $ from 'jquery';
import { not, notEmpty } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['composer-html-editor'],
  htmlContent: '',
  templateStylesTransformer: null,
  contentBeforeEdit: '',
  isEditMode: false,
  hasError: false,
  hasNoHtml: not('currentEditableObject.hasHtml'),
  init() {
    this._super(...arguments);
    if (this.get('hasNoHtml')) {
      this.set('isEditMode', true);
    }
  },
  setMode: Em.observer({
    dependentKeys: ['isVisible'],
    fn() {
      if (this.get('isVisible') && this.get('hasNoHtml')) {
        this.set('isEditMode', true);
      }
    },
    sync: true
  }),
  setContentOnOpen: Em.observer({
    dependentKeys: ['isEditMode'],
    fn() {
      if (this.get('isEditMode') && this.get('currentEditableObject.content')) {
        this.set('htmlContent', decodeUriAttributes(this.get('currentEditableObject.content')));
      }
    },
    sync: true
  }),
  focusEditor: Em.observer({
    dependentKeys: ['isEditMode'],
    fn() {
      schedule('afterRender', this, function () {
        if (this.get('isEditMode') && $('.modal-editor', this.element).length) {
          $('.modal-editor', this.element).focus();
        }
      });
    },
    sync: true
  }),
  syncAndFocus() {
    if (this.isDestroying) {
      return;
    }
    this.moveSelectionPastEntityOrBlock?.();
  },
  setBlock(htmlContent) {
    let encodedHtmlContent = encodeUriAttributes(htmlContent);
    this.get('currentEditableObject').set('content', encodedHtmlContent);
    if (this.get('hasNoHtml')) {
      this.send('delete');
      return;
    }
    this.set('isEditMode', false);
    this.syncAndFocus();
  },
  isHtmlInvalid(content) {
    try {
      $(content);
      return false;
    } catch (e) {
      return true;
    }
  },
  trimmedHtmlContent: trim('htmlContent'),
  hasHtmlContent: notEmpty('trimmedHtmlContent'),
  actions: {
    edit() {
      this.set('isEditMode', true);
    },
    save() {
      let htmlContent = this.get('htmlContent');
      if (this.isHtmlInvalid(htmlContent)) {
        this.set('hasError', true);
        return;
      }
      this.set('hasError', false);
      this.setBlock(htmlContent);
      if (this.get('templateTransformer')) {
        this.get('templateTransformer').transformHtmlBlockStyles([this.get('currentEditableObject')]);
        this.syncAndFocus();
      }
    },
    delete() {
      this.set('isEditMode', false);
      this.get('composerState').backspace();
      this.syncAndFocus();
    },
    cancel() {
      if (this.get('hasNoHtml')) {
        this.send('delete');
        return;
      }
      this.set('isEditMode', false);
      this.syncAndFocus();
    },
    hideEditor(id) {
      this.hideEditor?.(id);
    }
  }
});